import { ReactNode } from 'react';

import { tokens } from '@cast/design-system';

import { StackedAreaChart } from '../../_components/StackedAreaChart';

import {
  NetworkCostChartPoint,
  NetworkCostChartTotals,
} from '../_hooks/useNetworkCostChartData';

type NetworkAreaChartValueType = 'currency' | 'number';
type NetworkAreaChartMetricKey = 'egress' | 'ingress' | 'total';

const METRIC_SETTINGS: Record<
  NetworkAreaChartMetricKey,
  { color: string; title: string; tooltipTitle: string }
> = {
  egress: {
    color: tokens.theme.data.blue900,
    title: 'Egress',
    tooltipTitle: 'Egress',
  },
  ingress: {
    color: tokens.theme.data.blue300,
    title: 'Ingress',
    tooltipTitle: 'Ingress',
  },
  total: {
    color: tokens.theme.data.blue900,
    title: 'Total',
    tooltipTitle: 'Total',
  },
};

export type NetworkAreaChartProps = {
  title: string;
  testId: string;
  data: NetworkCostChartPoint[];
  totals: NetworkCostChartTotals;
  timeZone: string;
  unit: string;
  valueType: NetworkAreaChartValueType;
  yAxisFormatter?: (value: number) => string;
  metricFormatter?: (value: number) => { value: number; unit?: ReactNode };
  tooltipFormatter?: (value: number) => ReactNode;
  isLoading: boolean;
  error: Error | null | undefined;
  refetch: () => void;
};

export const NetworkAreaChart = ({
  title,
  testId,
  data,
  totals,
  timeZone,
  unit,
  valueType,
  yAxisFormatter,
  metricFormatter,
  tooltipFormatter,
  isLoading,
  error,
  refetch,
}: NetworkAreaChartProps) => {
  return (
    <StackedAreaChart<NetworkCostChartPoint, NetworkAreaChartMetricKey>
      title={title}
      testId={testId}
      data={data}
      totals={totals}
      metricSettings={METRIC_SETTINGS}
      metricKeys={['egress', 'ingress', 'total']}
      chartMetricKeys={['egress', 'ingress']}
      timeZone={timeZone}
      unit={unit}
      valueType={valueType}
      yAxisFormatter={yAxisFormatter}
      metricFormatter={metricFormatter}
      tooltipFormatter={tooltipFormatter}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
    />
  );
};
